import { Input, TimePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const TelegramTypeTemplateFields = ({
  typeKey,
  cabinetTelegram,
  patchCabinetTelegram,
  onDirty,
}) => {
  const handlePatchType = (patch) => {
    patchCabinetTelegram((p) => ({
      ...p,
      types: {
        ...p.types,
        [typeKey]: { ...p.types[typeKey], ...patch },
      },
    }));
    onDirty();
  };

  if (typeKey === 'admin_commerce') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Покупка прокси
          </div>
          <Input.TextArea
            rows={2}
            value={cabinetTelegram.types.admin_commerce?.template_purchase || ''}
            onChange={(e) => handlePatchType({ template_purchase: e.target.value })}
            aria-label="Шаблон: admin_commerce покупка"
          />
        </div>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Продление (в т.ч. автосписание с баланса)
          </div>
          <Input.TextArea
            rows={2}
            value={cabinetTelegram.types.admin_commerce?.template_renewal || ''}
            onChange={(e) => handlePatchType({ template_renewal: e.target.value })}
            aria-label="Шаблон: admin_commerce продление"
          />
        </div>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Пополнение баланса ЛК
          </div>
          <Input.TextArea
            rows={2}
            value={cabinetTelegram.types.admin_commerce?.template_balance_topup || ''}
            onChange={(e) => handlePatchType({ template_balance_topup: e.target.value })}
            aria-label="Шаблон: admin_commerce пополнение"
          />
        </div>
      </div>
    );
  }

  if (typeKey === 'regional_restrictions') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Ограничения введены
          </div>
          <Input.TextArea
            rows={2}
            value={cabinetTelegram.types.regional_restrictions?.template || ''}
            onChange={(e) => handlePatchType({ template: e.target.value })}
            aria-label="Шаблон: regional_restrictions"
          />
        </div>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Ограничения сняты
          </div>
          <Input.TextArea
            rows={2}
            value={cabinetTelegram.types.regional_restrictions?.template_restored || ''}
            onChange={(e) => handlePatchType({ template_restored: e.target.value })}
            aria-label="Шаблон: regional_restrictions восстановление"
          />
        </div>
      </div>
    );
  }

  if (typeKey === 'admin_modem_reserve_alert') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Резерв исчерпан
          </div>
          <Input.TextArea
            rows={3}
            value={cabinetTelegram.types.admin_modem_reserve_alert?.template || ''}
            onChange={(e) => handlePatchType({ template: e.target.value })}
            aria-label="Шаблон: admin_modem_reserve_alert"
          />
        </div>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Резерв восстановлен
          </div>
          <Input.TextArea
            rows={3}
            value={cabinetTelegram.types.admin_modem_reserve_alert?.template_restored || ''}
            onChange={(e) => handlePatchType({ template_restored: e.target.value })}
            aria-label="Шаблон: admin_modem_reserve_alert восстановление"
          />
        </div>
        <div className="sett-cell--muted" style={{ fontSize: 12 }}>
          Плейсхолдеры: {'{city}'}, {'{connection_name}'}, {'{unavailable_count}'},{' '}
          {'{free_modems}'}. Алерт — при каждом новом эпизоде исчерпания (после восстановления снова).
        </div>
      </div>
    );
  }

  if (typeKey === 'admin_periodic_report') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Время отправки отчётов (МСК)
          </div>
          <TimePicker
            format="HH:mm"
            value={
              cabinetTelegram.types.admin_periodic_report?.send_time_hhmm
                ? dayjs(cabinetTelegram.types.admin_periodic_report.send_time_hhmm, 'HH:mm')
                : dayjs('00:10', 'HH:mm')
            }
            onChange={(time) => {
              const v = time ? time.format('HH:mm') : '00:10';
              handlePatchType({ send_time_hhmm: v });
            }}
            aria-label="Время отправки admin_periodic_report"
          />
        </div>
        <div className="sett-cell--muted" style={{ fontSize: 12 }}>
          Ежедневно — за вчера; по понедельникам — за пн–вс; 1-го числа — за прошлый календарный месяц.
        </div>
      </div>
    );
  }

  if (typeKey === 'admin_sim_payment_overdue') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div>
          <div className="sett-cell--muted" style={{ marginBottom: 4 }}>
            Время проверки (МСК)
          </div>
          <TimePicker
            format="HH:mm"
            value={
              cabinetTelegram.types.admin_sim_payment_overdue?.send_time_hhmm
                ? dayjs(cabinetTelegram.types.admin_sim_payment_overdue.send_time_hhmm, 'HH:mm')
                : dayjs('09:00', 'HH:mm')
            }
            onChange={(time) => {
              const v = time ? time.format('HH:mm') : '09:00';
              handlePatchType({ send_time_hhmm: v });
            }}
            aria-label="Время проверки admin_sim_payment_overdue"
          />
        </div>
        <Input.TextArea
          rows={3}
          value={cabinetTelegram.types.admin_sim_payment_overdue?.template || ''}
          onChange={(e) => handlePatchType({ template: e.target.value })}
          aria-label="Шаблон: admin_sim_payment_overdue"
        />
      </div>
    );
  }

  return (
    <Input.TextArea
      rows={4}
      value={cabinetTelegram.types[typeKey]?.template || ''}
      onChange={(e) => handlePatchType({ template: e.target.value })}
      aria-label={`Шаблон: ${typeKey}`}
    />
  );
};

export default TelegramTypeTemplateFields;
